import { sortOptionsISelect } from '../helpers/sortISelect';
import { CareerStatus } from '../model/enumerations/career-status.model';
import { ISelect } from '../model/iSelect';

export const careerStatusEnum = (): Array<ISelect> => {
  const careerStatus: Array<ISelect> = [
    {
      label: "En Curso",
      value: CareerStatus.IN_PROGRESS,
    },
    {
      label: "Finalizado",
      value: CareerStatus.FINISHED,
    },
    {
      label: "Abandonado",
      value: CareerStatus.DROPPED,
    },
    {
      label: "Materias pendientes",
      value: CareerStatus.PENDING_SUBJECTS,
    },
  ];
  return sortOptionsISelect(careerStatus);
};
